import React from 'react';
import AdminDashboard from '../components/AdminDashboard';

const AdminPage: React.FC = () => <AdminDashboard />;

export default AdminPage;
